import useModal from 'src/components/Modals/hooks/useModal';
import StakeModal from 'src/components/Modals/StakeModal';
import VaultTermsDisclaimerModal from 'src/components/Vaults/VaultTermsDisclaimerModal';
import InsuranceFundRevenueModal from 'src/components/Modals/InsuranceFundRevenueModal';

export default function LiquidityModals() {
	const { currentModal } = useModal();

	return (
		<>
			{currentModal?.type === 'stake' && <StakeModal {...currentModal.props} />}

			{currentModal?.type === 'vault_terms_disclaimer' && (
				<VaultTermsDisclaimerModal {...currentModal.props} />
			)}

			{currentModal?.type === 'insurance_fund_revenue' && (
				<InsuranceFundRevenueModal />
			)}
		</>
	);
}
